var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C13.6522 0 15.7163 0.774373 17.2381 2.15277C18.76 3.53116 19.615 5.40066 19.615 7.35H20.86C21.152 7.35001 21.4333 7.44982 21.6475 7.62949C21.8618 7.80917 21.9933 8.05546 22.0158 8.31915L22.9966 19.8692C23.0202 20.1468 22.9212 20.4216 22.7211 20.6331C22.5211 20.8445 22.2366 20.9754 21.93 20.9968L21.8408 21H1.15928C0.851817 21 0.556951 20.8894 0.339544 20.6925C0.122138 20.4955 0 20.2285 0 19.95L0.00347785 19.8692L0.984225 8.31915C1.00671 8.05546 1.13823 7.80917 1.35251 7.62949C1.56678 7.44982 1.84802 7.35001 2.14002 7.35H3.38509C3.38509 5.40066 4.24005 3.53116 5.76189 2.15277C7.28374 0.774373 9.3478 0 11.5 0ZM19.7854 9.45H3.21351L2.41013 18.9H20.5887L19.7854 9.45ZM13.8186 11.55V13.65H9.18147V11.55H13.8186ZM11.5 2.1C10.0063 2.10008 8.57034 2.62242 7.4915 3.55809C6.41266 4.49377 5.77426 5.77054 5.70943 7.12215L5.70364 7.35H17.2964C17.2963 5.99711 16.7196 4.69648 15.6866 3.71933C14.6535 2.74219 13.2439 2.16397 11.7516 2.10525L11.5 2.1Z",
    fill: "#B22A2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingIcon);
export default __webpack_public_path__ + "static/media/shoppingIcon.59a34128721cadcdb183a6fee0128cbc.svg";
export { ForwardRef as ReactComponent };